import { render } from "./ExpedicionesRepartoRealizadoPage.vue?vue&type=template&id=648bfe6f&scoped=true"
import script from "./ExpedicionesRepartoRealizadoPage.vue?vue&type=script&lang=js"
export * from "./ExpedicionesRepartoRealizadoPage.vue?vue&type=script&lang=js"

import "./ExpedicionesRepartoRealizadoPage.vue?vue&type=style&index=0&id=648bfe6f&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648bfe6f"]])

export default __exports__